import { Star } from "lucide-react";

const ITEMS = ["OPENING SPRING 2027", "JOIN THE LAUNCH LIST — 20% OFF", "GENESEE COUNTY'S MONSTER FUN", "CLEAN • SAFE • SANITIZED", "FREE DELIVERY & SETUP"];

export const Marquee = () => {
    const row = (
        <div className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center font-display text-xl font-semibold tracking-wide text-white sm:text-2xl">
                    <span className="px-6">{item}</span>
                    <Star className="h-5 w-5 fill-monster-yellow text-monster-yellow" />
                </span>
            ))}
        </div>
    );
    return (
        <div data-testid="marquee" className="overflow-hidden border-y-2 border-monster-navy bg-monster-blue py-4" aria-hidden="true">
            <div className="animate-marquee flex w-max">
                {row}
                {row}
            </div>
        </div>
    );
};
